export default "dist/images/block-columns-tiled.9170bc8.png";